import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
// import { addBlog, addSeoRedirect } from "store/actions";
// import { useNavigate } from "react-router-dom";
import { cleanUrl } from ".";
import Loader from "components/shared/Loader";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { addSeoRedirect } from "store/actions/seoRedirects";
import { useHistory } from "react-router-dom";
import { updateMeta } from "store/actions/metaAction";

const AddSeoRedirect = () => {
	const dispatch = useDispatch();
	// const navigate = useNavigate();
	const history = useHistory();
	const navigate = history.push;
	const { loading, error } = useSelector(state => state.seoRedirects);
	useEffect(() => {
		if (error) toast.error(`${error}`);
	}, [error]);

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "إضافة لينك اعادة التوجيه",
				breadcrumb: "لينكات اعادة التوجيه",
				button: {
					show: false,
				},
			})
		);
	};

	const { register, handleSubmit, setValue } = useForm({
		mode: "onChange",
		reValidateMode: "onChange",
	});

	const onSubmit = data => {
		dispatch(addSeoRedirect({ data, navigate }));
	};
	if (loading) return <Loader />;

	return (
		<>
			<div className="acc-form">
				<div className="card">
					<div className="card-body">
						<form onSubmit={handleSubmit(onSubmit)}>
							<Col lg={12} md={12}>
								<Row>
									<Col xs={12}>
										<div className="form-item">
											<label>
												المصدر
												<small style={{ fontSize: "12px" }}>
													{" *"}
													برجاء اضافة العنوان القصير
												</small>
											</label>
											<textarea
												name="source"
												{...register("source", {
													required: true,
													onBlur: e => {
														let val = cleanUrl(e.target.value);
														if (val?.[val?.length - 1] === "/")
															val = val?.slice(0, -1);

														setValue("source", val);
													},
												})}
												dir="ltr"
												rows="5"
											></textarea>
										</div>
									</Col>

									<Col xs={12}>
										<div className="form-item">
											<label>الهدف</label>

											<textarea
												name="destination"
												className="form-control form-outline"
												{...register("destination", { required: true })}
												dir="ltr"
												rows="5"
											></textarea>
										</div>
									</Col>

									<Col xs={12}>
										<div className="form-item">
											<label>كود اعادة التوجيه</label>

											<input
												type="number"
												name="redirectCode"
												className="form-control form-outline"
												{...register("redirectCode", { required: true })}
												defaultValue={301}
											/>
										</div>
									</Col>
									<Col lg={4} xs={12}>
										<div className="form-item">
											<button type="submit" className="bt bt-success btn-block">
												اضافة
											</button>
										</div>
									</Col>
								</Row>
							</Col>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default AddSeoRedirect;
